webpackJsonp([18603711958221],{

/***/ 1828:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LabTrendNarrative","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"narrative","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-lab-trend-narrative-40991197ab2243c4c9ee.js